// Function to convert UTC date to IST and optionally return only the date
export const convertToIST = (utcDate: string, dateOnly = false) => {
  if (!utcDate || utcDate === '-') return "-";

  const date = new Date(utcDate);
  const months = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const offset = getTimezoneOffset(timezone);
  const istDate = new Date(date.getTime() + offset * 60 * 60 * 1000);

  let hours = istDate.getUTCHours();
  let minutes = istDate.getUTCMinutes();
  let day = istDate.getUTCDate();
  let month = istDate.getUTCMonth() + 1;
  let year = istDate.getUTCFullYear();

  if (isNaN(day)) return "-";

  if (dateOnly) {
    // Return only date in "DD Month YYYY" format
    return `${day} ${months[month - 1]} ${year}`;
  }

  // Otherwise return date + time
  return `${day} ${months[month - 1]} ${year}, ${hours === 0 ? 12 : hours > 12 ? hours - 12 : hours
    }:${minutes < 10 ? '0' : ''}${minutes} ${hours >= 12 ? 'PM' : 'AM'} IST`;
};

/**
 * function to get offset from the time zone selected
 * @param timeZone 
 * @returns 
 */
function getTimezoneOffset(timeZone) {
  const now = new Date();
  const options: any = {
    timeZone,
    hour: '2-digit',
    minute: '2-digit',
    timeZoneName: 'short'
  };
  const formatter = new Intl.DateTimeFormat([], options);
  const parts: any = formatter.formatToParts(now);
  const timeZoneName: any = parts.find(part => part.type === 'timeZoneName').value;
  //console.log(timeZoneName)
  // Extract offset from time zone name (e.g., "GMT+5" -> +5)
  const offsetMatch = timeZoneName.match(/GMT([+-]\d+):(\d+)/);
  if (offsetMatch) {
    const hours = parseInt(offsetMatch[1], 10);
    const minutes = parseInt(offsetMatch[2], 10);
    return hours + minutes / 60;
  }

  return 0;
}

export const convertUTCTimeToIST = (timeStr: string | null | undefined): string => {
  if (!timeStr) return timeStr || "";
  const parts = timeStr.split(":");
  const hours = parseInt(parts[0], 10);
  const minutes = parseInt(parts[1], 10);
  const seconds = parts[2] || "00";
  const totalMinutes = hours * 60 + minutes + (5 * 60 + 30);
  const wrappedMinutes = totalMinutes % (24 * 60);
  return [
    String(Math.floor(wrappedMinutes / 60)).padStart(2, "0"),
    String(wrappedMinutes % 60).padStart(2, "0"),
    seconds,
  ].join(":");
};

export const convertISTTimeToUTC = (timeStr: string | null | undefined): string => {
  if (!timeStr) return timeStr || "";
  const parts = timeStr.split(":");
  const hours = parseInt(parts[0], 10);
  const minutes = parseInt(parts[1], 10);
  const seconds = parts[2] || "00";
  const totalMinutes = hours * 60 + minutes - (5 * 60 + 30);
  const wrappedMinutes = ((totalMinutes % (24 * 60)) + 24 * 60) % (24 * 60);
  return [
    String(Math.floor(wrappedMinutes / 60)).padStart(2, "0"),
    String(wrappedMinutes % 60).padStart(2, "0"),
    seconds,
  ].join(":");
};